import React from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import Cards from '../../components/cards';
import Chart from '../../components/chart';
import CardList from '../../components/cardList';
import MapCard from '../../components/map';
import PieChartComponent from '../../components/pieChart';
import Text from '../../components/text/Text';
import './styles.css';

function Dashboard() {
  return (
    <body>
      <Navbar />
      <hr className="hr-min" />
      

      <main className="main-container">
        <Text as='h1' fontSize={56} variant="yellow-green">Dashboard</Text>
        <Cards />

        <div className="charts">
          <Chart />
          <PieChartComponent />
        </div>
                
        <div className="card-map">
          <CardList />
          <MapCard title="Localização" address="Avenida Reitor Miguel Calmon s/n Vale do - Canela, Salvador - BA, 40110-903" />
        </div>

      </main>

      <Footer />
  </body>
  );
}

export default Dashboard;
